// extracted by mini-css-extract-plugin
export default {"errorScreen":"DkbxNJOxGBc6qw5GvPd7","primaryBtn":"cWjNL1VcRBnvdYAyw_Lw","secondaryBtn":"fnVJaCjF8RkkGHrTO7jG"};